import React from 'react';

import deleteIcon from 'assets/delete_icon.svg';

const TrashIcon = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}): JSX.Element => (
  <img
    src={deleteIcon}
    alt="delete-icon"
    className={className}
    onClick={() => onClick()}
  />
);

export default TrashIcon;
